export default abstract class VeiculoRoutes {
  static readonly LIST: string = '/veiculos'
  static readonly DETAIL: string = '/veiculos/detalhes'
  static readonly CREATE: string = '/veiculos/adicionar'
}
